export default {
  getKeyword: (state) => state.keyword,
};
